import { cn } from '@/lib/utils';

import { WithRef } from '@/components/types';

import { gradientBorderStyling } from '@/styles/gradient';

export const commonStyles = cn(
  'p-4 relative overflow-hidden shadow-card dark:shadow-none border border-solid border-neutral-N04 bg-neutral-N00 transition-colors \
   dark:bg-neutral-dark-N94 dark:border-neutral-dark-N90 dark:text-neutral-dark-N00'
);
export const roudnessOptions = ['s', 'm', 'l', 'xl'] as const;
type Roundness = (typeof roudnessOptions)[number];
const roudnessClasses: Record<Roundness, `rounded${string}`> = {
  s: 'rounded',
  m: 'rounded-xl',
  l: 'rounded-3xl',
  xl: 'rounded-[2.25rem]',
};

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  roudnessLevel?: keyof typeof roudnessClasses;
  hasHoverEffect?: boolean;
  color?: 'neutral' | 'gradient';
  classNames?: {
    root: string;
  };
}

const Card = ({
  children,
  roudnessLevel = 'm',
  hasHoverEffect = false,
  color = 'neutral',
  classNames,
  ref,
  ...props
}: WithRef<HTMLDivElement, CardProps>) => {
  const hoverClasses =
    'hover:border-primary-P99 dark:hover:border-neutral-dark-N80 dark:hover:bg-neutral-dark-N94 cursor-pointer';
  const colorClasses = {
    gradient: `${gradientBorderStyling({
      borderWidth: 'p-px',
      borderRadius: roudnessClasses[roudnessLevel],
    })}`,
    neutral: '',
  };

  return (
    <div
      className={cn(
        commonStyles,
        roudnessClasses[roudnessLevel],
        hasHoverEffect && hoverClasses,
        colorClasses[color],
        classNames?.root
      )}
      ref={ref}
      data-tracker-component='card'
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;
